import { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie_consent", "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-fade-in-up max-w-sm">
      <div className="bg-card border border-border rounded-lg shadow-lg p-4 backdrop-blur-sm">
        <div className="flex items-start gap-3">
          <Cookie className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
          
          <div className="flex-1 min-w-0">
            <p className="text-sm text-foreground mb-2">
              Nur notwendige Cookies für Funktionalität. Kein Tracking.
            </p>
            <div className="flex gap-2 text-xs mb-2">
              <Link to="/datenschutz" className="text-primary hover:underline">
                Datenschutz
              </Link>
              <span className="text-muted-foreground">•</span>
              <Link to="/cookies" className="text-primary hover:underline">
                Cookies
              </Link>
            </div>
            <div className="flex gap-2">
              <Button
                onClick={acceptCookies}
                size="sm"
                className="bg-primary hover:bg-primary/90 text-primary-foreground"
              >
                OK
              </Button>
              <Button
                onClick={declineCookies}
                size="sm"
                variant="ghost"
                className="text-muted-foreground hover:text-foreground"
              >
                Ablehnen
              </Button>
            </div>
          </div>

          <button
            onClick={declineCookies}
            className="p-1 rounded hover:bg-muted/50 transition-colors flex-shrink-0"
            aria-label="Banner schließen"
          >
            <X className="w-4 h-4 text-muted-foreground" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
